<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('MODALANALISEVISITAASTEC.DOCUMENTOSDAANALISE')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">

            <b-notification type="is-info">                           
                <p>{{$t('MODALANALISEVISITAASTEC.MENSAGEMVISITACONCLUIDA')}}</p>
            </b-notification>            
  
             
            <div class="box ">      

                <div class="columns">
                    <div class="column is-4" >
                        <b-field  v-if="visualizarAnexos()">
                            <b-upload 
                                    @input="confirmarAnexo"
                                    v-model="fileList"                                                     
                                    accept=".pdf,.jpg,.jpeg,.png,.mp4,.mov,.wmv,.PNG,.PDF,.JPG,.JPEG,.MP4,.MOV,.WMV,.DOCX,.docx"                                                    
                                    drag-drop>
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p>
                                            <b-icon icon="upload"
                                                    size="is-medium">
                                            </b-icon>
                                        </p>
                                        <p>{{$t('ANEXOS.ARRASTEARQUIVOS')}}</p>
                                        <p>({{$t('ANEXOS.APENASPDF')}})</p>
                                    </div>
                                </section>
                            </b-upload>
                        </b-field>
                        <a v-if="visualizarAnexos()"  class="has-text-info" @click="adicionarUrlExterna()" :title="$t('GUIAATENDIMENTO.URLEXTERNA')">
                            <b-icon  icon="link" size="is-small"></b-icon>
                        </a>                                         
                    </div>
                    <div class="column is-8">
                        <div  class="b-table">
                            <div class="table-wrapper has-mobile-cards">    
                                <table v-if="anexos!=null && anexos.length>0" class="table is-striped">
                                    <thead>
                                        <tr>
                                            <th>Tipo</th>                        
                                            <th>Nome</th>
                                            <th>Data</th>
                                            <th>Ação</th>
                                        </tr>                                                
                                    </thead>
                                    <tbody>
                                        
                                        <tr :class="anexo.documentoDigital ? 'has-background-info-light' : '' " v-for="(anexo, index) in anexos" :key="index">
                                            <td> {{retornaTipoAnexo(anexo)}} </td>
                                            <td >                                        
                                                <p>
                                                    <a v-if=" anexo.formato==0" @click="visualizarAnexo(anexo.id, anexo.fileName)" class="is-size-7 text-nowrap"><b>{{ anexo.fileName }}</b></a>
                                                    <a v-else-if="anexo.formato==1" @click="visualizarUrlExternaAnexo(anexo.anexo)" class="is-size-7 text-nowrap"><b>{{ anexo.fileName }}</b></a>
                                                </p>
                                            </td>

                                            <td>{{ anexo.dataHora ? $moment(anexo.dataHora).format("DD/MM/YYYY") : ''}}</td>
                                            
                                            <td v-if="anexo.id ">        
                                                <div class="is-inline-flex">
                                                    <b-button 
                                                            icon-left="pencil"
                                                            type="is-primary"
                                                            size="is-small"
                                                            :title="$t('SISTEMA.EDITAR')"
                                                            @click="editarAnexo(anexo)"></b-button>
                                                    
                                                    <span >
                                                        <b-button 
                                                            class="ml-2"
                                                            icon-left="delete"
                                                            type="is-danger"
                                                            size="is-small"
                                                            :title="$t('ANEXOS.REMOVERANEXO')"
                                                            @click="removerAnexo(anexo.id)"></b-button> 
                                                                                                                                                            
                                                    </span>
                                                    

                                                </div>                                   
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>                 

            </div>


        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                     :loading="salvandoDados"
                      @click="confirmar">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click="$emit('close'); $emit('removerConfirmarConcluirVisitaAstec');  ">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import moment from 'moment';
    import modalPreencherTipoAnexo from '@/components/atendimento/modalPreencherTipoAnexo'   
    import modalUrlExternaAnexoAstec  from '@/components/astecs/modalUrlExternaAnexoAstec'
    import modalEditarAnexoAstec from '@/components/astecs/modalEditarAnexoAstec'    
    import { mapState } from 'vuex'    
    
    export default {
        props: {
            id: Number,                                                                                      
        },
        data() {
            return {                                               
                salvandoDados :false,
                files: [],                     
                fileList:null,
                anexos:[],  
                guia: {
                    id:null
                }                        
            }
        },
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
        },        

        mounted() {

            this.guia.id = this.id;
            this.loadGuia();
            

        },
        methods: {

            loadGuia(){
                this.loadAnexos();
            },
            adicionarUrlExterna(){

                this.$buefy.modal.open({
                    parent: this,
                    component: modalUrlExternaAnexoAstec,
                    props: {
                        guia: this.guia                                              
                    },
                    events: {
                        loadData: this.loadGuia
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })                
       
            },             
            visualizarAnexos(){
            
                if(this.guia.id != 0)
                    return true;                
            },            
            editarAnexo(anexo)    {

                if(anexo.formato==0){
                    this.$buefy.modal.open({
                    parent: this,
                    component: modalEditarAnexoAstec,
                    props: {
                        anexo: anexo                        
                    },
                    events: {
                        loadData: this.loadGuia                        
                    },
                    hasModalCard: true,
                    trapFocus: true
                    })                        

                }else if (anexo.formato==1){

                    this.$buefy.modal.open({
                    parent: this,
                    component: modalUrlExternaAnexoAstec,
                    props: {
                        anexo: anexo,
                        editar:true                        
                    },
                    events: {
                        loadData: this.loadGuia                        
                    },
                    hasModalCard: true,
                    trapFocus: true
                })    

                }

            

            },

            incluirAnexo(tipoAnexoId) {

                const formData = new FormData()
                formData.append('id', this.guia.id);
                formData.append('type', 'guia');      
                formData.append('tipoAnexoSelecionadoId', tipoAnexoId);                                             
                formData.append('anexo', this.fileList, this.fileList.name);
                               
                this.isLoading = true;                    
                this.$http.post('/api/astecs/anexoGuia', formData, {
                    progress(e) {
                        return true;
                    }
                }).then(response => {                    
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: response.data.sucesso,
                        type: 'is-success'
                    })
                    this.loadAnexos();
                    
                    this.isLoading = false;                    
                }, error => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error.message,
                        type: 'is-danger'
                    })
                });
       
            },            

            confirmarAnexo(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalPreencherTipoAnexo,
                    props:{
                        astec: true
                    },
                    events: {
                        loadData: this.loadAnexos,
                        inlcuirAnexo: this.incluirAnexo                        
                    },
                    hasModalCard: true,
                    trapFocus: true
                })  
            },               

            removerAnexo(id) {
                const anexo = this.anexos.filter(x => x.id == id)[0]
                this.$buefy.dialog.confirm({
                    title: this.$t('ANEXOS.EXCLUIRANEXO'),
                    message: this.$t('ANEXOS.CONFIRMAEXCLUSAO') + anexo.fileName.replace(/^.*[\\/]/, '') + '</b> ?',
                    confirmText: this.$t('SISTEMA.CONFIRMAR'),                    
                    cancelText: this.$t('SISTEMA.CANCELAR'),                      
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {

                        const removerAnexo = {
                            tipo: "guia",
                            anexoId: id
                        }

                        this.isLoading = true;    
                        this.$http.post('/api/astecs/excluirAnexoGuia', removerAnexo)
                            .then((res) => {
                                if (res.body.erro) {
                                    this.$buefy.toast.open({
                                        duration: 5000,
                                        message: res.body.erro,
                                        type: 'is-danger'
                                    })
                                } else {
                                    this.loadAnexos()
                                }
                            }).finally(() => {                                
                                this.isLoading = false;  
                                 
                            });
                            
                    }
                })
            },               
            visualizarUrlExternaAnexo(url){
                window.open(url);
            },              
            visualizarAnexo(anexoId, fileName) {                
                window.open('/api/astecs/anexoPdf?id=' + this.guia.id + '&anexoId=' + anexoId + '&fileName=' + fileName);
            },            
            retornaTipoAnexo(anexo){
              
              if(parseInt(anexo.formato) == 0){
                  return anexo.tipoAnexoNome ?? 'NAO DEFINIDO';
              }else{
                  return 'LINK EXTERNO'
              }                 

            },             

            loadAnexos() {              
                this.fileList = null;                  
                this.anexos = null;
                this.$http.get('/api/astecs/anexos?id=' + this.id)
                    .then(res => {
                        if(res.data){
                            this.anexos = res.data  
                        }

                    })
            },                 

            async confirmar() {

                 this.$buefy.dialog.confirm({
                    message: this.$t('ASTECS.MENSAGEMCONFIRMARCONCLUSAOASTECS'),
                    cancelText: 'Não',
                    confirmText: 'Sim',                        
                    onConfirm: () => {                        
                        this.salvandoDados=true;
                            const params = [];                                            
                            params.push(`id=${this.guia.id}`);                                                                          
                                                                            
                            try {
                                this.$http.get(`/api/astecs/ConfirmarConclusaoVisitaAstec?${params.join('&')}`)
                                        .then(res => res.data)
                                        .then(data => {
                                            return true;
                                        }).finally(() => {      
                                            this.salvandoDados=false;  
                                            this.$emit('close');                                                                                  
                                            this.$router.push({ name: 'astecs'});                                                                 
                                        });                              
                                
                            } catch (e) {
                                this.salvandoDados=false;                        
                                console.error(e);
                            }

                            return true; 
                    },
                    onCancel: () => {                        
                        this.guia.confirmarAstec = false;
                    },
                });
            
            },
            

        }
    }
</script>